import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRegDocParagraphIdsQueryVariables = Types.Exact<{
  regulatoryDocumentId: Types.Scalars['ID'];
}>;


export type GetRegDocParagraphIdsQuery = { __typename?: 'Query', regulatoryDocument?: { __typename?: 'RegulatoryDocument', id: string, paragraphs: Array<{ __typename?: 'RegulatoryDocumentParagraph', id: string }> } | null };


export const GetRegDocParagraphIdsDocument = gql`
    query GetRegDocParagraphIds($regulatoryDocumentId: ID!) {
  regulatoryDocument(id: $regulatoryDocumentId) {
    id
    paragraphs {
      id
    }
  }
}
    `;

/**
 * __useGetRegDocParagraphIdsQuery__
 *
 * To run a query within a React component, call `useGetRegDocParagraphIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegDocParagraphIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegDocParagraphIdsQuery({
 *   variables: {
 *      regulatoryDocumentId: // value for 'regulatoryDocumentId'
 *   },
 * });
 */
export function useGetRegDocParagraphIdsQuery(baseOptions: Apollo.QueryHookOptions<GetRegDocParagraphIdsQuery, GetRegDocParagraphIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegDocParagraphIdsQuery, GetRegDocParagraphIdsQueryVariables>(GetRegDocParagraphIdsDocument, options);
      }
export function useGetRegDocParagraphIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegDocParagraphIdsQuery, GetRegDocParagraphIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegDocParagraphIdsQuery, GetRegDocParagraphIdsQueryVariables>(GetRegDocParagraphIdsDocument, options);
        }
export type GetRegDocParagraphIdsQueryHookResult = ReturnType<typeof useGetRegDocParagraphIdsQuery>;
export type GetRegDocParagraphIdsLazyQueryHookResult = ReturnType<typeof useGetRegDocParagraphIdsLazyQuery>;
export type GetRegDocParagraphIdsQueryResult = Apollo.QueryResult<GetRegDocParagraphIdsQuery, GetRegDocParagraphIdsQueryVariables>;